/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum AutochargeFrequency {
  Daily = "daily",
  Weekly = "weekly",
}

export function instanceOfAutochargeFrequency(value: any): boolean {
  for (const key in AutochargeFrequency) {
    if (Object.prototype.hasOwnProperty.call(AutochargeFrequency, key)) {
      if (
        AutochargeFrequency[key as keyof typeof AutochargeFrequency] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AutochargeFrequencyFromJSON(json: any): AutochargeFrequency {
  return AutochargeFrequencyFromJSONTyped(json, false);
}

export function AutochargeFrequencyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AutochargeFrequency {
  return json as AutochargeFrequency;
}

export function AutochargeFrequencyToJSON(
  value?: AutochargeFrequency | null,
): any {
  return value as any;
}

export function AutochargeFrequencyToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AutochargeFrequency {
  return value as AutochargeFrequency;
}
